import React, { useState } from 'react';
import classes from './style.module.css'
import Aux from 'react-aux'
import { Col } from 'react-bootstrap';

import ProfileMenu from "../UI/ProfileMenu"
import ModeToggleButton from "../UI/ToggleButtonSingle"
import InfoText from "../UI/InfoText"
import ExportData from "../ExportData"
import { SET_SELECTION_STATE, SET_SOCCER_LEAGUES_STATE, SET_SOCCER_MATCHES_STATE } from "../../redux/actions"
import { connect } from "react-redux"
import { HEADER_CONTROLS, TICKLER_TAB_BUTTON } from "../../constants/Constants"
import { passDateToString } from '../../util/date/date-utils'
import { currentDateStr } from '../../util/date/date-utils'
import DatePicker from '../../components/UI/DatePicker'
import FilterModal from '../LeagueTable/Filter/FilterModal';
import { getPreviousNthDayStr, passDateToStringWithFormat } from '../../util/date/date-utils';
import { ButtonGroup, ToggleButton } from 'react-bootstrap';
import bookIcon from "../../assets/images/book.png"

const Header = props => {
    const [selectionDate, setSelectionDate] = useState(currentDateStr())
    const [radioValue, setRadioValue] = useState('1');

    const modeToggleChangeHandler = (targettab, value) => {
        console.log("vivek...")
        setRadioValue(value)
        const selectionState = { ...props.selectionState };
        selectionState.tab = targettab;
        props.setSelectionState(selectionState);
    }

    const updateTier = (val) => {
        console.log("in upudate tier" + val);
        props.tierChangeHandler(val);

    }
    const selectionDateChangeHandler = (event) => {
        //console.log("selectionDate: " + event)
        const newDate = passDateToString(event);
        //console.log(newDate);
        const selectionState = { ...props.selectionState };
        selectionState.selectionDate = newDate;
        props.setSelectionState(selectionState);
        setSelectionDate(newDate)
    }

    //let matchSelectionPanel = props.selectionState.mode === MODE_MATCHES ? <MatchSelectionPanel updateTier={updateTier}/> : null

    const radios = [
        { tab: TICKLER_TAB_BUTTON.HOT_JOCKEY, value: '1' },
        { tab: TICKLER_TAB_BUTTON.HOT_TRAINER, value: '2' },
        { tab: TICKLER_TAB_BUTTON.COURSE_DISTANCE, value: '3' },
        { tab: TICKLER_TAB_BUTTON.LONGEST_TRAVELLER, value: '4' },
        { tab: TICKLER_TAB_BUTTON.FIRST_TIME_VISORS, value: '5' },
        { tab: TICKLER_TAB_BUTTON.FIRST_TIME_BLINKERS, value: '6' },
        { tab: TICKLER_TAB_BUTTON.CHEEK_PIECE, value: '7' },
        { tab: TICKLER_TAB_BUTTON.TONGUE_STRAP, value: '8' },
    ];


    return (
        <Aux>
            <Col className={classes.HeaderLeft} xs={11}>
                <ExportData label={HEADER_CONTROLS.EXPORT_DATA_BUTTON.label} mode={props.selectionState.mode}
                    selectionDate={props.selectionState.selectionDate}
                    currentTab={props.selectionState.tab}
                    home={props.selectionState.home}
                    away={props.selectionState.away} />
                 <FilterModal handleSubmit={props.matchFilterHandler} />
                 <a href="https://winningmore.com/manual.htm" target="_blank"><img style={{width: "29px", height: "34px", marginTop:"10px", marginRight:"5px"}} src={bookIcon}/></a> 
                 <ButtonGroup style={{ marginTop: "10px", borderRadius:"1px" }}>
                    {radios.map((radio, idx) => (
                        <ToggleButton
                            key={idx}
                            id={`radio-${idx}`}
                            type="radio"
                            variant='success'
                            name="radio"
                            size="sm"
                            value={radio.value}
                            checked={radioValue === radio.value}
                            onChange={(e) => modeToggleChangeHandler(radio.tab, e.currentTarget.value)}
                            >
                            {radio.tab.label}
                        </ToggleButton>
                    ))}
                </ButtonGroup>
                <DatePicker selectedDate={selectionDate} selectedDateChanged={selectionDateChangeHandler} />

            </Col>
            <Col className={classes.HeaderRight} xs={1}>
                <ProfileMenu logoutClicked={props.logoutClicked} />
            </Col>
        </Aux>
    );
}

const mapStateToProps = (state, ownProps) => {
    return {
        selectionState: state.selectionState,
        ...ownProps
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSoccerLeaguesState: payload =>
            dispatch({ type: SET_SOCCER_LEAGUES_STATE, payload: payload }),
        setSelectionState: payload =>
            dispatch({ type: SET_SELECTION_STATE, payload: payload }),
        setSoccerMatchesState: payload =>
            dispatch({ type: SET_SOCCER_MATCHES_STATE, payload: payload }),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);